<template>
	<div class="panel-body">
		<H1 class="form-panel-view-title"> {{contestType}} {{name}} ({{shortName}})</H1>

		<v-btn
			:disabled="form.formSchema.sections.length===0"
			@click="saveFormToDatabase"
		>Zapisz formularz
		</v-btn>

		<v-btn
			:disabled="form.formSchema.sections.length===0"
			@click="removeFromDatabase"
		>Usuń formularz
		</v-btn>

		<SectionPanel v-model="form" v-if="sectionRenderCondition" v-on:renderIndex="renderSection"
			style="padding-left: 20px;"/>

		<GroupPanel v-model="form" v-if="form.selected.sectionIndex !== null" style="padding-left: 20px;"/>

		<FieldPanel v-model="form" v-if="form.selected.groupIndex !== null" style="padding-left: 20px;"/>

		<div class="contest-offer-view-content">
			<vue-form-generator :schema="formGenerator.schema" :model="formGenerator.model"
				:options="formGenerator.formOptions"/>
		</div>

		<egranty-error-list-popup
			title="Nie można edytować formularza"
			:error-list="unsuccessfulDeleteDialogMessages"
			:is-open="showUnsuccessfulDeleteDialog"
			@close="closeUnsuccessfulDeleteDialog"
		/>
	</div>
</template>

<script>
	import Vue from "vue";
	import VueFormGenerator from "vue-form-generator";
	import "vue-form-generator/dist/vfg.css";
	import SectionPanel from "./components/section/SectionPanel";
	import GroupPanel from "./components/group/GroupPanel";
	import FieldPanel from "./components/field/FieldPanel";
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import {PublicContest} from "@/api/generated/PublicContest";
	import {AgencyContest} from "@/api/generated/AgencyContest";
	import {ContestReportTemplate} from "@/api/generated/ContestReportTemplate";
	import {AgencyContestReportTemplate} from "@/api/generated/AgencyContestReportTemplate";
	import EgrantyErrorListPopup from "../../../genericComponents/EgrantyErrorListPopup";

	Vue.use(VueFormGenerator);

	export default {
		name: "FormGeneratorView",

		components: {
			EgrantyErrorListPopup,
			FieldPanel,
			GroupPanel,
			SectionPanel,
			"vue-form-generator": VueFormGenerator.component,
		},

		created () {
			this.getFormTemplate();
		},

		methods: {
			getFormTemplate () {
				if (this.$route.params.contestType === "PUBLIC") {
					this.contestType = "Konkurs";
					if (this.$route.params.formType !== undefined) {
						PublicContest.getForm(this, this.$route.params.contestId, this.$route.params.formType, response => {
							if (response.form) {
								this.form.formSchema = genericFormUtil.decodeSchema(response.form);
							}
							if (response.name) {
								this.name = response.name;
							}
							if (response.shortName) {
								this.shortName = response.shortName;
							}
							// to taki hak żeby się wyrenderowało "Dodaj sekcje formularza"
							this.sectionRenderCondition = true;
						});
					} else {
						PublicContest.getReportForm(this, this.$route.params.reportId, response => {
							if (response.volunteerReportSchema) {
								this.form.formSchema = genericFormUtil.decodeSchema(response.volunteerReportSchema);
							}
							if (response.name) {
								this.name = response.name;
							}
							if (response.shortName) {
								this.shortName = response.shortName;
							}
							// to taki hak żeby się wyrenderowało "Dodaj sekcje formularza"
							this.sectionRenderCondition = true;
						});
					}
				} else if (this.$route.params.contestType === "AGENCY") {
					this.contestType = "Nabór";
					AgencyContest.getForm(this, this.$route.params.contestId, this.$route.params.formType, response => {
						if (response.form) {
							this.form.formSchema = genericFormUtil.decodeSchema(response.form);
						}
						if (response.name) {
							this.name = response.name;
						}
						if (response.shortName) {
							this.shortName = response.shortName;
						}
						this.sectionRenderCondition = true;
					});
				} else if (this.$route.params.reportTemplatesType === "contest-report-templates") {
					ContestReportTemplate.getSchema(this, this.$route.params.templateId, response => {
						if (response.schema) {
							this.form.formSchema = genericFormUtil.decodeSchema(response.schema);
						}
						this.sectionRenderCondition = true;
					});
				} else if (this.$route.params.reportTemplatesType === "agency-contest-report-templates") {
					AgencyContestReportTemplate.getSchema(this, this.$route.params.templateId, response => {
						if (response.schema) {
							this.form.formSchema = genericFormUtil.decodeSchema(response.schema);
						}
						this.sectionRenderCondition = true;
					});
				}
			},

			saveFormToDatabase () {
				if (this.$route.params.contestType !== undefined) {
					this.saveContestForm();
				} else if (this.$route.params.reportTemplatesType !== undefined) {
					let data = {
						templateId: this.$route.params.templateId,
						schema: genericFormUtil.encodeSchema(this.form.formSchema),
					};
					this.saveReportForm(data);
				}
			},

			saveContestForm () {
				let data = {
					contestId: this.$route.params.contestId,
					formType: this.$route.params.formType,
					formSchema: genericFormUtil.encodeSchema(this.form.formSchema),
				};
				switch (this.$route.params.contestType) {
					case "PUBLIC":
						if (this.$route.params.formType !== undefined) {
							PublicContest.putForm(this, data, () => {
								this.$messagesBus.$emit("success", "Formularz został zapisany");
								this.$router.go(-1);

							}, (errorResponse) => {
								this.$messagesBus.$emit("error", errorResponse.errors[0], errorResponse);
							});
						} else {
							PublicContest.putReportForm(this, {
								reportId: this.$route.params.reportId,
								formSchema: genericFormUtil.encodeSchema(this.form.formSchema),
							}, () => {
								this.$messagesBus.$emit("success", "Formularz został zapisany");
								this.$router.go(-1);
							}, (errorResponse) => {
								this.$messagesBus.$emit("error", errorResponse.errors[0], errorResponse);
							});
						}
						break;
					case "AGENCY":
						AgencyContest.putForm(this, data, () => {
							this.$messagesBus.$emit("success", "Formularz został zapisany");
							this.$router.go(-1);
						}, (errorResponse) => {
							this.$messagesBus.$emit("error", errorResponse.errors[0], errorResponse);
						});
						break;
				}
			},

			saveReportForm (data) {
				switch (this.$route.params.reportTemplatesType) {
					case "contest-report-templates":
						ContestReportTemplate.putSchema(this, data, () => {
							this.$messagesBus.$emit("success", "Formularz został zapisany");
							this.$router.go(-1);
						});
						break;
					case "agency-contest-report-templates":
						AgencyContestReportTemplate.putSchema(this, data, () => {
							this.$messagesBus.$emit("success", "Formularz został zapisany");
							this.$router.go(-1);
						});
						break;
				}
			},

			removeFromDatabase () {
				if (this.$route.params.contestType !== undefined) {
					this.removeContestForm();
				} else if (this.$route.params.reportTemplatesType !== undefined) {
					this.removeReportForm();
				}
			},

			emptyForm () {
				this.form.formSchema = {
					sections: [],
				};

				this.form.selected = {
					sectionIndex: null,
					groupIndex: null,
					fieldIndex: null,
				};
				this.formGenerator.schema.groups = [];
			},

			removeContestForm () {
				switch (this.$route.params.contestType) {
					case "PUBLIC":
						if (this.$route.params.formType !== undefined) {
							PublicContest.deleteForm(this, this.$route.params.contestId, this.$route.params.formType, () => {
								this.$messagesBus.$emit("success", "Formularz został usunięty");
							});
						} else {
							PublicContest.deleteReportForm(this, this.$route.params.reportId, () => {
								this.$messagesBus.$emit("success", "Formularz został usunięty");
							});
						}
						break;
					case "AGENCY":
						AgencyContest.deleteForm(this, this.$route.params.contestId, this.$route.params.formType, () => {
							this.$messagesBus.$emit("success", "Formularz został usunięty");
						});
						break;
				}
				this.emptyForm();
			},

			removeReportForm () {
				switch (this.$route.params.reportTemplatesType) {
					case "contest-report-templates":
						ContestReportTemplate.deleteSchema(this, this.$route.params.templateId, () => {
							this.$messagesBus.$emit("success", "Formularz został usunięty");
						});
						break;
					case "agency-contest-report-templates":
						AgencyContestReportTemplate.deleteSchema(this, this.$route.params.templateId, () => {
							this.$messagesBus.$emit("success", "Formularz został usunięty");
						});
						break;
				}
				this.emptyForm();
			},

			renderSection (index) {
				this.formGenerator.schema = genericFormUtil.getSectionSchemaFromSchema(this.form.formSchema, index);
				let model = genericFormUtil.buildModelFromSchema(this.form.formSchema);
				this.formGenerator.model = model.sections[index].fields;
			},

			closeUnsuccessfulDeleteDialog () {
				this.showUnsuccessfulDeleteDialog = false;
			},
		},

		data () {
			return {
				sectionRenderCondition: false,
				showUnsuccessfulDeleteDialog: false,
				unsuccessfulDeleteDialogMessages: null,
				name: "",
				shortName: "",
				contestType: "",

				form: {
					formSchema: {
						sections: [],
					},

					selected: {
						sectionIndex: null,
						groupIndex: null,
						fieldIndex: null,
					},
				},

				formGenerator: {
					model: {},
					schema: {
						groups: [],
					},
				},
				formOptions: {
					validateAfterLoad: true,
					validateAfterChanged: true,
					validateAsync: true,
				},
			};
		},

	};
</script>

<style scoped>
	.form-panel-view-title {
		margin-left: 20px;
	}
</style>
